import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import LicenseStep2 from "./addLicenseSteps/LicenseStep2";
import LicenseStep1 from "./addLicenseSteps/LicenseStep1";
import AuthApi from "../../../../services/api/authApi";
import { useUser } from "../../../../context/userContext";

const payment_method = {
  card: "card",
  bank_transfer: "bank_transfer",
};
const signupSteps = [
  //   {
  //       label: "signup_to_cloudarchive",
  //       component: SignupStep1
  //   },
  {
    //   label: "signup_to_cloudarchive",
    component: LicenseStep1,
    fields: ["number_of_licenses", "payment_method"],
  },
  {
    //   label: "signup_to_cloudarchive",
    component: LicenseStep2,
    fields: {
      [payment_method.card]: [
        // "cardHolderName",
        // "cardNumber",
        // "expiryDate",
        // "cvv",
      ],
      [payment_method.bank_transfer]: ["payment_proof"],
    },
  },
];

const AddLicenseForm = ({ addLicenseFrm, onHide, action, planInfo, title }) => {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const { user } = useUser();
  const navigate = useNavigate();
  const bankDataObj = localStorage.getItem("bank_info");
  const [currentStep, setCurrentStep] = useState(signupSteps[0]);
  const [totalAmount, setTotalAmount] = useState(0);
  const [bankInfo, setBankInfo] = useState(
    bankDataObj ? JSON.parse(bankDataObj) : {}
  );
  const [paymentMethod, setPaymentMethod] = useState(null);
  const currentStepIndex = signupSteps.indexOf(currentStep);
  const {
    watch,
    register,
    setValue,
    control,
    trigger,
    getFieldState,
    formState: { errors },
  } = useForm();

  const [planDetails, setPlanDetails] = useState({});

  const handleSteps = async (e) => {
    console.log("handleSteps flow is called: ", currentStepIndex);
    if (currentStepIndex < 1) {
      setCurrentStep(signupSteps[currentStepIndex + 1]);
    }
  };

  const getPlanInfo = async (id, type) => {
    try {
      const { data, code } = await AuthApi.getPlanInfo(id, type);
      if (code === 200) {
        setPlanDetails({
          ...data,
          amount:
            data?.prices?.find((price) => price?.duration == planInfo?.duration)
              ?.price || "",
          duration: planInfo?.duration || 1,
        });
      } else {
        setPlanDetails(planInfo);
      }
    } catch (error) {}
  };
  useEffect(() => {
    if (planInfo?.id) {
      getPlanInfo(planInfo?.id, planInfo?.type || "public");
    }
  }, [planInfo]);

  return (
    <Form>
      <currentStep.component
        bankInfo={bankInfo}
        planInfo={planDetails}
        handleSteps={handleSteps}
        paymentMethod={paymentMethod}
        setPaymentMethod={setPaymentMethod}
        addLicenseFrm={addLicenseFrm}
        totalAmount={totalAmount}
        setTotalAmount={setTotalAmount}
        watch={watch}
        register={register}
        errors={errors}
        control={control}
        getFieldState={getFieldState}
        setValue={setValue}
        onHide={onHide}
        action={action}
        user={user}
      />
    </Form>
  );
};

export default AddLicenseForm;
